import { useTranslate } from '@tolgee/react';
import Button, { ButtonProps } from '@amf/shared/components/button/Button';
import ContractList from '@amf/shared/components/contract/ContractList';
import Contract from '@amf/shared/components/contract/Contract';
import Container from '@amf/shared/components/layout/Container';
import { ContractFragment } from '@amf/shared/types/graphql';
import { GetServerSideProps } from 'next';
import { sdk } from '@amf/shared/lib/graphQlClient';
import { getNavigation, getPartners, NavigationProps } from '@amf/shared/utils/navigation';
import { getLanguageLocale } from '@amf/shared/utils/languages';

type Props = {
  contracts: ContractFragment[];
  links: { player: string; team: string };
  buttonProps: ButtonProps;
  buttonEnabled?: boolean;
};

export type ContractsPageProps = NavigationProps & {
  contracts: ContractFragment[];
};

function ContractsPage({ contracts, links, buttonProps, buttonEnabled }: Props) {
  const { t } = useTranslate();
  return (
    <Container>
      <div className='ContractHeader'>
        <h1>{t('contracts.title')}</h1>
        {buttonEnabled && (
          <a
            href={`https://portal.malyfotbal.cz/${process.env.NEXT_PUBLIC_UNION}/contract`}
            target='_blank'
            rel='noreferrer'
          >
            <Button {...buttonProps}>{t('contracts.create')}</Button>
          </a>
        )}
      </div>
      <p>{t('contracts.description')}</p>
      <ContractList>
        {contracts.map(contract => (
          <Contract
            key={contract.id}
            contract={contract}
            prefixes={{ player: links.player, team: links.team }}
          />
        ))}
        {contracts.length === 0 && <p className='ContractList__empty'>{t('contracts.empty')}</p>}
      </ContractList>
    </Container>
  );
}

export default ContractsPage;

export const getServerSideProps =
  (): GetServerSideProps<ContractsPageProps> =>
  async ({ locale }) => {
    const { contracts } = await sdk.ContractList({ union: process.env.NEXT_PUBLIC_UNION });

    return {
      props: {
        contracts,
        navigation: await getNavigation(getLanguageLocale(locale!)),
        partners: await getPartners(),
      },
    };
  };
